var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1231 23H7.37685C5.51143 23 4 21.5018 4 19.6527V4.34732C4 2.49822 5.51143 1 7.37685 1H15.8423L20.5 5.63778V19.6527C20.5 21.5018 18.9886 23 17.1231 23Z",
    fill: "#9954A1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5.63777H16.7994C16.2754 5.63777 15.8493 5.21763 15.8493 4.69821L15.8423 1",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7513 9.06134C15.693 9.01055 15.6162 8.98747 15.5417 8.99901L10.7698 9.62C10.6371 9.63616 10.5393 9.74928 10.5393 9.88086V14.9873C10.2295 14.7195 9.81034 14.5533 9.3469 14.5533C8.39672 14.5533 7.62354 15.2481 7.62354 16.1C7.62354 16.9518 8.39672 17.6467 9.3469 17.6467C10.2971 17.6467 11.0703 16.9518 11.0703 16.1V11.4229L15.3111 10.8712V13.6045C15.0107 13.3505 14.6078 13.1936 14.1653 13.1936C13.2408 13.1936 12.4885 13.8699 12.4885 14.701C12.4885 15.5321 13.2408 16.2085 14.1653 16.2085C15.0899 16.2085 15.8421 15.5321 15.8421 14.701V9.25756C15.8421 9.18138 15.8095 9.10982 15.7513 9.05904V9.06134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.041c2c0e86cfc5f4a24bf14521231a44.svg";
export { ForwardRef as ReactComponent };